export default (payload) => ({
  type: 'NEW_HARDWARE_STATE',
  payload,
});
